import * as z from "zod/v4";

export const getStripeConnectionStatus = {
  name: "getStripeConnectionStatus" as const,
  input: z.object({}),
  output: z.object({ connected: z.boolean() }),
};
